import { useParams, useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import Auth from '../components/Auth'
import { Header } from '../components/Header'
import { ModuleDevRouteGuard } from '../components/ModuleDevRouteGuard'
import DovolenaView from './DovolenaView'

/**
 * Otevření žádosti z odkazu: po přihlášení zůstane na stejné URL.
 */
export default function DovolenaSharePage() {
  const { shareToken } = useParams<{ shareToken: string }>()
  const navigate = useNavigate()
  const { user, authenticated } = useAuth()

  if (!shareToken) {
    return null
  }

  if (!authenticated || !user) {
    return (
      <Auth
        onAuthSuccess={() => {
          navigate(`/dovolena/share/${encodeURIComponent(shareToken)}`, { replace: true })
        }}
      />
    )
  }

  return (
    <ModuleDevRouteGuard module="dovolena">
      <div className="app">
        <Header
          leftButtons={
            <button type="button" onClick={() => navigate('/intranet')} className="back-button">
              ← Zpět
            </button>
          }
          title="Žádosti o nepřítomnost"
          rightContent={
            <span style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem' }}>{user.name}</span>
          }
        />
        <DovolenaView user={user} uiRole="zadatel" shareToken={shareToken} />
      </div>
    </ModuleDevRouteGuard>
  )
}
